/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_4_QInputs */

const en_mk_pricing_faq_4_q = /** @type {(inputs: Mk_Pricing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do agents count as billable seats?`)
};

const id_mk_pricing_faq_4_q = /** @type {(inputs: Mk_Pricing_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah agen dihitung sebagai kursi berbayar?`)
};

/**
* | output |
* | --- |
* | "Do agents count as billable seats?" |
*
* @param {Mk_Pricing_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_4_q = /** @type {((inputs?: Mk_Pricing_Faq_4_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_4_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_4_q(inputs)
	return en_mk_pricing_faq_4_q(inputs)
});